// extracted by mini-css-extract-plugin
export default {"Container":"Main_Container__jtpFA","Columns":"Main_Columns__TPQiC","Button":"Main_Button__sJQpP","Spinner":"Main_Spinner__3fa73"};